import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@vapor/material";
const LogoutButton = ({ beforeLogout = () => { }, buttonText = "Logout", buttonVariant = "contained", className, env = "prod", idToken, mode = "tab", popupHeight = 900, popupWidth = 800, redirectUrl, }) => {
    let windowOptions;
    if (mode === "popup") {
        windowOptions = `width=${popupWidth},height=${popupHeight}`;
    }
    const endsessionUrlSuffix = env === "prod" ? "" : "-stage";
    const logoutUrl = `https://identity${endsessionUrlSuffix}.teamsystem.com/connect/endsession`;
    const tsIdRedirectUri = env === "dev"
        ? "https://login-dev.teamsystemdigital.com/logout"
        : env === "test"
            ? "https://login-test.teamsystemdigital.com/logout"
            : "https://login.teamsystemdigital.com/logout";
    const tsIdUriEndpoint = `${logoutUrl}?id_token_hint=${idToken}&state=${encodeURIComponent(redirectUrl)}&post_logout_redirect_uri=${encodeURIComponent(tsIdRedirectUri)}`;
    const logout = () => {
        if (mode === "redirect") {
            window.location.href = tsIdUriEndpoint;
        }
        else {
            window.open(tsIdUriEndpoint, "logoutpage", windowOptions);
        }
    };
    return (_jsx(Button, Object.assign({ className: className, variant: buttonVariant, onClick: () => {
            beforeLogout();
            logout();
        } }, { children: buttonText })));
};
export default LogoutButton;
